// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3R8mi","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2Omqp"};